<div class="modal-container" role="dialog" aria-modal="true" aria-labelledby="modal-basic-title" aria-describedby="modal-description">
  <!-- Skip link for keyboard users -->
  <!-- <a href="#modal-actions" class="skip-link sr-only-focusable">Zu den Aktionen springen</a> -->

  <div class="modal-header p-3 p-md-4 pb-0 pb-md-0">
    <h1 class="modal-title popup-title" id="modal-basic-title" #modalTitle tabindex="0">{{ title }}</h1>
    @if (!action) {
    <button type="button" class="btn-close btn-close-custom" aria-label="Modal schließen" (click)="dismissModal()" tabindex="0"
            (keydown)="handleKeyNavigation($event, 'close')"></button>
    }
    @if(action && action === 'disclaimer'){
    <button type="button" class="btn-close" aria-label="Modal schließen" (click)="dismissModal()" tabindex="0"
            (keydown)="handleKeyNavigation($event, 'close')">
    </button>
    }
    @if(action && action === 'applicationExists'){
    <button type="button" class="btn-close" aria-label="Modal schließen" (click)="dismissModal()" tabindex="0"
            (keydown)="handleKeyNavigation($event, 'close')">
    </button>
    }
    @if(action && action === 'fileUploadError'){
    <button type="button" class="btn-close" aria-label="Modal schließen" (click)="dismissModal()" tabindex="0"
            (keydown)="handleKeyNavigation($event, 'close')">
    </button>
    }
    @if(action && action === 'addressCheckError'){
    <button type="button" class="btn-close" aria-label="Modal schließen" (click)="dismissModal()" tabindex="0"
            (keydown)="handleKeyNavigation($event, 'close')">
    </button>
    }
    @if(action && action === 'abort'){
    <button type="button" class="btn-close" aria-label="Modal schließen" (click)="dismissModal()" tabindex="0"
            (keydown)="handleKeyNavigation($event, 'close')"></button>
    }
    @if(action && action === 'later'){
    <button type="button" class="btn-close" aria-label="Modal schließen" (click)="dismissModal()" tabindex="0"
            (keydown)="handleKeyNavigation($event, 'close')"></button>
    }
  </div>
  @if(message || submessage){
  <div class="modal-body popup-body p-3 p-md-4 pb-0 pb-md-0" id="modal-description">
    <div aria-live="polite">
      {{ message }}<br />@if (submessage) {<br />
      {{ submessage }}
      }
    </div>
  </div>
  }

  <div class="modal-body p-3 p-md-4" [ngClass]="{ 'pt-4 pt-md-5': !action }" id="modal-actions">
    <div class="d-grid justify-content-center">
      @if(!action){
      <button type="button" class="btn btn-primary w-100" (click)="dismissModal()" tabindex="0" aria-label="OK - Modal schließen">OK</button>
      }
      @if(action === 'disclaimer'){
      <button type="button" class="btn btn-primary w-100" (click)="dismissModal()" tabindex="0" aria-label="OK - Disclaimer akzeptieren">OK</button>
      }
    @if(action === 'applicationExists'){
    <button type="button" class="btn btn-primary w-100" (click)="dismissModal()" tabindex="0" aria-label="OK - Antrag bereits vorhanden bestätigen">OK</button>
    }
    @if(action === 'fileUploadError'){
    <button type="button" class="btn btn-primary w-100" (click)="dismissModal()" tabindex="0" aria-label="OK - Datei-Upload-Fehler bestätigen">OK</button>
    }
    @if(action === 'addressCheckError'){
    <button type="button" class="btn btn-primary w-100" (click)="dismissModal()" tabindex="0" aria-label="OK - Adressprüfungs-Fehler bestätigen">OK</button>
    }
    <!-- @if(action === 'phoneNumberNotFound'){
    <button type="button" class="btn btn-primary w-100" (click)="logOutEbankingNavigate()" tabindex="0" aria-label="OK - Telefonnummer nicht gefunden, zu E-Banking navigieren">OK</button>
    } -->

    @if(action && action === 'alreadyExists'){
    <button type="button" class="btn btn-primary w-100" (click)="logout()" tabindex="0" aria-label="OK - Bereits vorhanden, abmelden">
      OK
    </button>
    }
    @if(action && action === 'redirect'){
    <button type="button" class="btn btn-primary w-100" (click)="logout()" tabindex="0" aria-label="OK - Weiterleitung, abmelden">
      OK
    </button>
    }
    @if(action && action === 'ageMismatchError'){
    <button type="button" class="btn btn-primary w-100" (click)="logout()" tabindex="0" aria-label="OK - Altersabweichung, abmelden">
      OK
    </button>
    }
    @if(action && action === 'timeout'){
    <button type="button" class="btn btn-primary w-100" (click)="timeout()" tabindex="0" aria-label="OK - Zeitüberschreitung">
      OK
    </button>
    }
    @if(action && action === 'abort'){
    <button type="button" class="btn btn-primary w-100" (click)="continueLater()" tabindex="0" aria-label="Später fortsetzen">
      Später fortsetzen
    </button>
    }
    @if(action && action === 'abort'){
    <button type="button" class="btn btn-primary w-100" (click)="cancelApp()" tabindex="0" aria-label="Antrag stornieren">
      Stornieren
    </button>
    }

    @if(action && action === 'later'){
    <button type="button" class="btn btn-primary w-100" (click)="continueAfterLegi()" tabindex="0" aria-label="Zurück zur vorherigen Seite">
      Zurück
    </button>
    }

    @if(action && action === 'later'){
    <button type="button" class="btn btn-outline-secondary w-100 mt-3" (click)="continueManualLegi()" tabindex="0" aria-label="Manuell legitimieren">
      Manuell legitimieren
    </button>
    }
  </div>
  @if(action && action === 'logout'){
  <div class="modal-body p-3 p-md-4" [ngClass]="{ 'pt-4 pt-md-5': !action }">
    <div class="d-grid">
      @if(action && action === 'logout'){
      <button type="button" class="btn btn-outline-secondary-custom w-100" (click)="dismissModal()" tabindex="0" aria-label="Eingeloggt bleiben">
        Eingeloggt bleiben
      </button>
      }
      @if(action && action === 'logout'){
      <button type="button" class="btn btn-outline-secondary mt-3 w-100" (click)="logout()" tabindex="0" aria-label="Ausloggen">
        Ausloggen
      </button>
      }
    </div>
  </div>
  }
  @if (action === 'alert') {
  <div class="modal-body p-0 mt-40">
    <div class="d-flex modal-button-custom flex-column flex-lg-row">
      <button
        type="button"
        class="btn btn-outline-secondary btn-secondary-custom w-100"
        (click)="activeModal.close()"
        tabindex="0"
        aria-label="Abbrechen"
      >
       Abbrechen
      </button>
      <button
        type="button"
        class="btn btn-primary btn-primary-custom w-100"
        (click)="delete()"
        tabindex="0"
        aria-label="Datei löschen"
      >
       Datei löschen
      </button>
    </div>
  </div>
  }
</div>

<!-- Live region for screen reader announcements -->
<div aria-live="polite" aria-atomic="true" class="sr-only" id="modal-announcements"></div>
</div>
